<div class="bmc-bots-list" [ngClass]="{'bmc-bots-list__hidden': isLoading}">
    <ng-container *ngIf="botsList.length && botsList.length > 0">
        <h4 class="bz-space--stack-m">{{'RPA_BOTS.LIST_TITLE' | translate}}</h4>
        <bzg-input class="bz-space--stack-m" [placeholder]="'RPA_BOTS.LIST_SEARCH_BY' | translate" name="search-box" [(ngModel)]="searchValue" actionIcnPosition="right">
            <bzg-icon nameIcon="icon-search"></bzg-icon>
        </bzg-input>
    </ng-container>
    <ul class="bmc-bots-list__items">
        <ng-container *ngIf="botsList.length">
            <li class="bmc-bots-list__item bz-space--inset-m bz-space--stack-s bz-shadow--xs bz-border-radius--m" (click)="onSelectedBot(bot)" [ngClass]="{'bz-color-bg--theme-100': bot.id === currentBot?.id}" *ngFor="let bot of botsList | searchBy : searchValue : ['name']">
                <h5 class="bz-font-weight--semibold">{{bot.name}}</h5>
                <svg class="bz-icn bz-icon-svg--16">
                    <use href="#icon-arrow-right-bold"></use>
                </svg>
            </li>
        </ng-container>
    </ul>
</div>

<bz-loading *ngIf="isLoading" [size]="'s'" class="bmc-bots-list__loading">
    {{'GLOBAL.LOADING_DATA' | translate}}
</bz-loading>